export enum DashboardSourceRequiringReviewEnum {
    LowCyberPosture = 'lowCyberPosture',
    MissingDataTypes = 'missingDataTypes',
    MissingEmployees = 'missingEmployees',
    MissingCategories = 'missingCategories',
    MissingActivities = 'missingActivities',
    TypeNotFoundInActivities = 'typeNotFoundInActivities',
}